import {SeatingPlanModel} from "../SeatingPlanModel";
import {useSeatingPlanStore} from "../../../api/SeatingPlanStore";
import {useFormDialogAction} from "../../../components/form-dialog/FormDialogProvider";
import {NewNeighbourhoodFormComponent} from "../NewNeighbourhoodFormComponent";
import {randomColor} from "../../../components/color-picker/ColorPicker";
import {ListItemIcon, ListItemText, MenuItem} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import React, {useCallback} from "react";
import {PageAction} from "../../../components/page-action/PageActionHandler";
import {usePermission} from "../../../util/access/UseAccess";
import {SeatingPlans_Admin} from "../../../util/access/Permission";

export const newNeighbourhoodAction: PageAction<SeatingPlanModel> = {
    type: 'menu-item',
    component: (model, actionHandler) => (
        <CreateNewSeatingPlanNeighbourhoodMenuItem model={model} onClick={actionHandler} key="newNeighbourhoodAction"/>
    )
};

function CreateNewSeatingPlanNeighbourhoodMenuItem({model, onClick}: {
    model: SeatingPlanModel,
    onClick: () => void,
}) {
    const plan = model.plan;
    const createNewNeighbourhood = useSeatingPlanStore(state => state.createNewNeighbourhood);
    const {canAdmin} = usePermission({canAdmin: SeatingPlans_Admin});

    const handleCreateNeighbourhood = useFormDialogAction({
        title: 'Create New Neighbourhood',
        description: 'Enter the details for the new neighbourhood.',
        submitButtonText: 'Create',
        renderForm: NewNeighbourhoodFormComponent,
        action: (openDialog) => openDialog({
            initialValue: {name: '', displayColor: randomColor(), notes: null, slackChannelId: null},
            onSubmit: (form) => createNewNeighbourhood(plan, form),
            successMessage: 'Created new neighbourhood',
            errorMessage: 'Failed to create a neighbourhood. Please try again later.',
        }),
    }, [plan, createNewNeighbourhood]);

    const handleClick = useCallback(() => {
        handleCreateNeighbourhood();
        onClick();
    }, [onClick, handleCreateNeighbourhood]);

    return canAdmin ? (
        <MenuItem onClick={handleClick}>
            <ListItemIcon>
                <AddIcon/>
            </ListItemIcon>
            <ListItemText>
                Add Neighbourhood
            </ListItemText>
        </MenuItem>
    ) : null;
}
